export default __webpack_public_path__ + "static/media/myResume.54cbcfdd.docx";